module.exports = __webpack_public_path__ + "img/3.b59512ff.svg";